export enum CitationStatus {
  PayNow = 'PayNow',
  Warning = 'Warning',
  Pending = 'Pending',
  PastDue = 'PastDue',
  Delinquent = 'Delinquent',
  Canceled = 'Canceled',
  Paid = 'Paid',
  Suspension = 'Suspension',
  Released = 'Released',
  Confirmed = 'Confirmed',
  Waived = 'Waived',
}

export const citationStatusMap: Record<CitationStatus, string> = {
  [CitationStatus.PayNow]: 'Pay Now',
  [CitationStatus.Warning]: 'Warning',
  [CitationStatus.Pending]: 'Pending',
  [CitationStatus.PastDue]: 'Past Due',
  [CitationStatus.Delinquent]: 'Delinquent',
  [CitationStatus.Canceled]: 'Canceled',
  [CitationStatus.Paid]: 'Paid',
  [CitationStatus.Released]: 'Released',
  [CitationStatus.Suspension]: 'Suspension',
  [CitationStatus.Confirmed]: 'Confirmed',
  [CitationStatus.Waived]: 'Waived',
};

export const citationStatusColorMap: Record<CitationStatus, string> = {
  [CitationStatus.PayNow]: '#C1FFEA',
  [CitationStatus.Warning]: '#FFD889',
  [CitationStatus.Pending]: '#DCDCDC',
  [CitationStatus.Confirmed]: '#DCDCDC',
  [CitationStatus.PastDue]: '#FFA39E',
  [CitationStatus.Delinquent]: '#FFD889',
  [CitationStatus.Suspension]: '#FFD889',
  [CitationStatus.Canceled]: '#DCDCDC',
  [CitationStatus.Waived]: '#DCDCDC',
  [CitationStatus.Paid]: '#C1FFEA',
  [CitationStatus.Released]: '#C1FFEA',
};

export enum CitationType {
  EIQIntelliTicket = 'EIQIntelliTicket',
  EIQViolation = 'EIQViolation',
}
